import { Injectable } from '@angular/core';
import { ShoppingCartData } from 'src/app/home/home';
import { UserAddressComponent, UserSearchDeliveryLocationInfo } from '../interfaces/delivery';
import { isArray } from 'util';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  setAppVersion(version: string) {
    localStorage.setItem('app_version', version);
  }

  getAppVersion() {
    return localStorage.getItem('app_version');
  }

  clearLocalStorage() {
    localStorage.clear();
  }

  unsetLocalStorage() {
    this.unsetAccessToken();
    this.unsetAllAccountData();
    this.unsetOfferList();
    this.unsetPaymentToken();
    this.unsetAllOrderData();
    this.unsetAllShoppingData();
    this.unsetAllDeliveryLocation();
    this.unsetShippingModal();
    // TODO: FOR TESTING PURPOSE OF PRODUCT RECO
    this.unsetProductReco();
  }

  checkoutSuccessfull() {
    this.unsetShoppingCartData();
    this.unsetTipAmount();
    this.unsetPromoCode();
  }

  getAccessToken(): string {
    return localStorage.getItem('accessToken');
  }

  setAccessToken(token): void {
    localStorage.setItem('accessToken', token);
  }

  unsetAccessToken():void {
    localStorage.removeItem('accessToken');
  }

  // Account
  unsetAllAccountData() {
    this.unsetCurrentAccountID();
    this.unsetAccountUsername();
    this.unsetAccountEmail();
  }

  isLoggedIn(): boolean {
    return (localStorage.getItem('currentAccountId') && localStorage.getItem('accessToken')) ? true : false;
  }

  getCurrentAccountID(): string {
    return localStorage.getItem('currentAccountId');
  }

  setCurrentAccountID(data): void {
    localStorage.setItem('currentAccountId', data);
  }

  unsetCurrentAccountID(): void {
    localStorage.removeItem('currentAccountId');
  }

  setAccountUsername(username: string) {
    localStorage.setItem('username', username);
  }

  getAccountUsername() {
    return localStorage.getItem('username');
  }

  unsetAccountUsername(): void {
    localStorage.removeItem('username');
  }

  setAccountEmail(email: string) {
    localStorage.setItem('email', email);
  }

  getAccountEmail() {
    return localStorage.getItem('email');
  }

  unsetAccountEmail(): void {
    localStorage.removeItem('email');
  }

  // Payment
  setPaymentToken(token: string): void {
    localStorage.setItem('paymentToken', token);
  }

  getPaymentToken(): string {
    return localStorage.getItem('paymentToken');
  }

  unsetPaymentToken(): void {
    localStorage.removeItem('paymentToken');
  }

  // Orders
  setTipAmount(amount): void {
    localStorage.setItem('tipAmount', amount);
  }

  getTipAmount() {
    return localStorage.getItem('tipAmount');
  }
  

  unsetTipAmount(): void {
    localStorage.removeItem('tipAmount');
  }

  setOrderDetailInfo(data): void {
    localStorage.setItem('orderDetailInfo', JSON.stringify(data));
  }

  getOrderDetailInfo() {
    return JSON.parse(localStorage.getItem('orderDetailInfo'));
  }

  unsetOrderDetailInfo(): void {
    localStorage.removeItem('orderDetailInfo');
  }

  setOrderNumber(data): void {
    localStorage.setItem('orderNumber', JSON.stringify(data));
  }

  getOrderNumber() {
    return localStorage.getItem('orderNumber');
  }

  unsetOrderNumber() {
    localStorage.removeItem('orderNumber');
  }

  setPaymentFailureMsg(data): void {
    localStorage.setItem('paymentFailure', JSON.stringify(data));
  }

  getPaymentFailureMsg() {
    return JSON.parse(localStorage.getItem('paymentFailure'));
  }

  unsetPaymentFailureMsg(): void {
    localStorage.removeItem('paymentFailure');
  }

  setEstablishmentDeliveryData(data):void {
    localStorage.setItem('deliveryData', JSON.stringify(data));
  }

  getEstablishmentDeliveryData() {
    return JSON.parse(localStorage.getItem('deliveryData'));
  }

  unsetEstablishmentDeliveryData(): void {
    localStorage.removeItem('deliveryData');
  }

  unsetAllOrderData(): void {
    this.unsetTipAmount();
    this.unsetOrderDetailInfo();
    this.unsetPaymentFailureMsg();
    this.unsetEstablishmentDeliveryData();
  }

  // Offer List

  setEstablishmentIDofAddress(establishmentData) {
    localStorage.setItem('establishmentData', JSON.stringify(establishmentData));
  }

  getEstablishmentIDofAddress() {
    return JSON.parse(localStorage.getItem('establishmentData'));
  }

  unsetEstablishmentDataofAddress() {
    localStorage.removeItem('establishmentData');
  }

  unsetOfferList() {
    this.unsetEstablishmentDataofAddress();
  }

  // Product Details

  // Cart
  unsetAllShoppingData() {
    this.unsetShoppingCartData();
    this.unsetCartEstablishmentID();
  }

  setShoppingCartData(data: any): void {
    localStorage.setItem('cartLocalData', JSON.stringify(data));
    // if (data.length > 0) {
    //   this.setCartEstablishemtID(data[0].offer.establishmentId);
    // }
  }

  unsetShoppingCartData(): void {
    localStorage.removeItem('cartLocalData');
  }

  getShoppingCartData() {
    return JSON.parse(localStorage.getItem('cartLocalData'));
  }

  getCartQuantityFromLocalStorage(): number {
    let cartData = JSON.parse(localStorage.getItem('cartLocalData'));

    if ( isArray(cartData)) {
      if (cartData.length === 0 ) {
        return 0;
      } else {
        if (cartData.length > 1) {
          let quantity: number = 0;
          Object.entries(cartData).forEach(([key,value]) => {

            let qty: number = value['quantity'];
            quantity = quantity + qty;
          });
          return quantity;
        } else {
          return cartData[0].quantity;
        }
      }
    }
  }

  setCartEstablishemtID(data) {
    localStorage.setItem('cartEstablishmentID', data);
  }

  unsetCartEstablishmentID() {
    localStorage.removeItem('cartEstablishmentID');
  }

  setPromoCode(promoCode) {
    localStorage.setItem('promoCode', promoCode);
  }

  getPromoCode() {
    return localStorage.getItem('promoCode');
  }

  unsetPromoCode() {
    localStorage.removeItem('promoCode');
  }

  // PlaceOrder

  // Delivery Location

  unsetAllDeliveryLocation() {
    this.unsetUserSearchGeoLocationAddress();
    this.unsetUserSearchGeoLocationPoint();
    this.unsetUserAddressComponent();
    this.unsetUserAllDeliveryAddress();
    this.unsetUserDeliveryAddress();
  }

  getUserDeliveryAddress(): any {
    // return JSON.parse(this.decrypt(localStorage.getItem('userAddress')));
    return JSON.parse(localStorage.getItem('userDeliveryAddress'));
  }

  getUserAllDeliveryAddresses(): any {
    return JSON.parse(localStorage.getItem('userAllDeliveryAddresses'));
  }

  setUserSearchGeoLocationAddress(data): void {
    localStorage.setItem('userSearchLocationAddress', JSON.stringify(data));
  }

  setUserSearchGeoLocationPoint(data): void {
    localStorage.setItem('userSearchLocationPoint', JSON.stringify(data));
  }

  setUserAddressComponent(data): void {
    localStorage.setItem('userAddressComponent', JSON.stringify(data));
  }

  setUserDeliveryLocation(data): void {
    localStorage.setItem('deliveryLocation', data);
  }

  getUserSearchGeoLocationAddress(): UserSearchDeliveryLocationInfo['address'] {
    return JSON.parse(localStorage.getItem('userSearchLocationAddress'));
  }

  getUserSearchGeoLocationPoint(): UserSearchDeliveryLocationInfo['geoLocation'] {
    return JSON.parse(localStorage.getItem('userSearchLocationPoint'));
  }

  getUserAddressComponent(): UserAddressComponent {
    return JSON.parse(localStorage.getItem('userAddressComponent'));
  }

  getUserDeliveryLocation(): boolean {
    return localStorage.getItem('deliveryLocation') === 'true' ? true : false;
  }

  unsetUserSearchGeoLocationAddress() {
    localStorage.removeItem('userSearchLocationAddress');
  }

  unsetUserSearchGeoLocationPoint() {
    localStorage.removeItem('userSearchLocationPoint');
  }

  unsetUserAddressComponent() {
    localStorage.removeItem('userAddressComponent');
  }

  unsetUserAllDeliveryAddress() {
    localStorage.removeItem('userAllDeliveryAddresses');
  }

  unsetUserDeliveryAddress() {
    localStorage.removeItem('userDeliveryAddress');
  }
  

  // Coupon / Discounts
  setCoupnModal(number) {
    localStorage.setItem('couponModal', number);
  }

  getCouponModal() {
    return localStorage.getItem('couponModal') === "1" ? true : false;
  }

  // Shipping 
  setShippingModal(isShowed) {
    localStorage.setItem('shippingModal', isShowed);
  }

  getShippingModal() {
    localStorage.getItem('shippingModal');
  }

  unsetShippingModal() {
    localStorage.removeItem('shippingModal');
  }

  // California Proposition
  setCaliforniaProposition(willHandle):void {
    localStorage.setItem('handle', willHandle);
  }

  getCaliforniaProposition():string {
    return localStorage.getItem('handle');
  }

  // TODO: FOR TESTING PURPOSE OF PRODUCT RECO
  setProductReco(email: string): void {
    localStorage.setItem('prodRecoEmail', email);
  }

  getProductReco(): string {
    return localStorage.getItem('prodRecoEmail');
  }

  unsetProductReco() {
    this.unsetProductRecoId();
    localStorage.removeItem('prodRecoEmail');
  }

  setProductRecoID(id: string): void {
    localStorage.setItem('prodRecoEmailId', id);
  }

  getProductRecoId(): string {
    return localStorage.getItem('prodRecoEmailId');
  }

  unsetProductRecoId() {
    localStorage.removeItem('prodRecoEmailId');
  }
}
